<!-- contact -->
<template>
  <div class="contact">
    <div class="bgBox section1">
      <div class="s1_innerBox typeArea">
        <div class="topTitle centerTop">
          <div class="p1"><span>CONTACT </span>US</div>
          <div class="p2"></div>
        </div>
        <div class="bodyBox">
          <div class="left">
            <el-carousel
              indicator-position="outside"
              trigger="click"
              :interval="10000"
            >
              <el-carousel-item :key="1" class="key1">
                <div class="downLoad" @click="downLoad(1)">Download</div>
                <img src="../../static/images/contact/LiLiang.jpg" alt="" />
              </el-carousel-item>
              <el-carousel-item :key="2" class="key2">
                <div class="downLoad" @click="downLoad(2)">Download</div>
                <img
                  src="../../static/images/contact/ZhanggGuiHua.jpg"
                  alt=""
                />
              </el-carousel-item>
              <el-carousel-item :key="3" class="key3">
                <div class="downLoad" @click="downLoad(3)">Download</div>
                <img src="../../static/images/contact/HeLi.jpg" alt="" />
              </el-carousel-item>
              <el-carousel-item :key="4" class="key4">
                <div class="downLoad" @click="downLoad(4)">Download</div>
                <img src="../../static/images/contact/LiZhiPing.jpg" alt="" />
              </el-carousel-item>
            </el-carousel>
            <!-- <div class="p1">Shenzhen Summit New Materials Co., Ltd</div>
            <div class="line"></div>
            <div class="item ">
              <img src="../../static/images/contact/地址.png" alt="">
              <div class="label">Address:</div>
              <div class="text">&nbsp;&nbsp;&nbsp;&nbsp; 2 / F, Workshop No. 3, Huahan Technology Industrial Park,</div>
            </div>
            <div class="item item1">
              <img class="visd" src="../../static/images/contact/地址.png" alt="">
              <div class="label visd">Address: </div>
              <div class="text">
                &nbsp;&nbsp;&nbsp;&nbsp;No.19, Lanjin 4th Road, Pingshan District, </div>
            </div>
            <div class="item">
              <img src="../../static/images/contact/服务热线.png" alt="">
              <div class="label">Service hotline：</div>
              <div class="text">Phone（+86 0755-29128802）</div>
            </div>
            <div class="item">
              <img class="visd" src="../../static/images/contact/服务热线.png" alt="">
              <div class="label visd">Service hotline：</div>
              <div class="text">Ms.He（+86 191 2839 0596 / +86 186 8155 9268）</div>
            </div>
            <div class="item item2">
              <img class="visd" src="../../static/images/contact/服务热线.png" alt="">
              <div class="label visd">Service hotline：</div>
              <div class="text">Mr.Zhang（+86 191 2839 0686 / +86 138 0989 7866）</div>
            </div>
            <div class="item">
              <img src="../../static/images/contact/邮箱.png" alt="">
              <div class="label">Email address：</div>
              <div class="text">Ms.He（aheli@levimelt.com）</div>
            </div>
            <div class="item">
              <img class="visd" src="../../static/images/contact/邮箱.png" alt="">
              <div class="label visd">Email address：</div>
              <div class="text">Mr.Zhang（sales@levimelt.com）</div>
            </div> -->
          </div>
          <div class="right">
            <baidu-component
              class="bm-view"
              ak="UmeYALQE9awE98LBNtNivQfr8hEoNP7W"
            ></baidu-component>
          </div>
        </div>
      </div>
    </div>
    <div class="bgBox section2">
      <div class="s2_innerBox typeArea">
        <div class="bodyBox">
          <div class="item item1">
            <div class="p1">Zhejiang pilotscale-experiment base</div>
            <div class="btBox">
              <div class="label">
                Huzhailong Industrial Zone, Wuyi County, Jinhua City, Zhejiang
                Province
              </div>
            </div>
          </div>
          <div class="item item2">
            <div class="p1">Shanghai Sales Center</div>
            <div class="btBox">
              <div class="label">
                Room 911, Building 3 , Century Financial Plaza, Lujiazui, 799
                South Yanggao Road, Pudong New Area, Shanghai
              </div>
              <div class="label">+86 131 2236 9456</div>
            </div>
          </div>
          <div class="item item3">
            <div class="p1">Nanjing Sales Center</div>
            <div class="btBox">
              <div class="label">
                Room A-1,1813, Greenland Intercity Space Station, South Square,
                Nanjing South Railway Station, Jiangning District, Nanjing
              </div>
              <div class="label">+86 198 5090 5866</div>
            </div>
          </div>
          <div class="item item4">
            <div class="p1">Chengdu Sales Center</div>
            <div class="btBox">
              <div class="label">
                701, Block B, Air China Century Center, No. 1, Hanghang Road,
                Wuhou District, Chengdu
              </div>
              <div class="label">+86 186 8155 9268</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bgBox section3">
      <div class="s3_innerBox typeArea">
        <div class="topTitle centerTop">
          <div class="p1">ONLINE<span> MESSAGE</span></div>
          <div class="p2"></div>
        </div>
        <div class="bodyBox">
          <el-input
            class="input"
            v-model="input1"
            placeholder="Your name:"
          ></el-input>
          <el-input
            class="input"
            v-model="input2"
            placeholder="Telephone:"
          ></el-input>
          <el-input
            class="input"
            v-model="input3"
            placeholder="Email:"
          ></el-input>
          <el-input
            type="textarea"
            :rows="5"
            placeholder="Your message:"
            v-model="textarea"
          >
          </el-input>
        </div>
        <div class="btn">
          <div class="boxT" @click="btnFunc()">Submit a message</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaiduComponent from "@/components/baiduMap";
export default {
  name: "contact",
  components: {
    BaiduComponent,
  },
  data() {
    return {
      textarea: "",
      input1: "",
      input2: "",
      input3: "",
    };
  },
  computed: {},
  watch: {},
  created() {
    this.init();
  },
  mounted() {
    this.$store.commit("savePageId", "");
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  },
  methods: {
    downLoad(type) {
      let a = document.createElement("a");
      if (type == 1) {
        a.href = "./static/images/contact/LiLiang.jpg";
        a.download = "LiLiang.jpg";
      } else if (type == 2) {
        a.href = "./static/images/contact/ZhanggGuiHua.jpg";
        a.download = "ZhanggGuiHua.jpg";
      } else if (type == 3) {
        a.href = "./static/images/contact/HeLi.jpg";
        a.download = "HeLi.jpg";
      } else {
        a.href = "./static/images/contact/LiZhiPing.jpg";
        a.download = "LiZhiPing.jpg";
      }

      a.click();
    },
    init() {},
    btnFunc() {
      if (this.input1 == "") {
        this.$message.error("Your name");
      } else if (this.input2 == "") {
        this.$message.error("Telephone");
      } else if (this.input3 == "") {
        this.$message.error("Email");
      } else if (this.textarea == "") {
        this.$message.error("Your message");
      } else {
        this.$message({
          type: "success",
          message: "Thanks",
          center: true,
        });
        this.input1 = "";
        this.input2 = "";
        this.input3 = "";
        this.textarea = "";
      }
    },
  },
};
</script>

<style lang='less' scoped>
.contact {
  width: 100%;
  min-width: 1200px;

  .section1 {
    width: 100%;
    height: 830px;

    .s1_innerBox {
      height: 100%;

      .topTitle {
        .p1 {
          margin-top: 193px;
        }
      }

      .bodyBox {
        display: flex;
        margin-top: 130px;
        position: relative;

        .left {
          width: 586px;
          text-align: left;
          margin-right: 20px;
          position: relative;
          .downLoad {
            position: absolute;
            right: 0;
            bottom: 0;
            width: 80px;
            height: 25px;
            border: solid 1px #c30000;
            font-size: 14px;
            color: #c30000;
            line-height: 25px;
            text-align: center;
            right: 5px;
            bottom: -35px;
            cursor: pointer;
            z-index: 999;
          }
          /deep/ .el-carousel {
            .el-carousel__container {
              height: 340px;

              .el-carousel__arrow {
                display: none;
              }

              .el-carousel__item {
                display: flex;
                justify-content: space-between;
                overflow: initial;
                img {
                  height: 100%;
                }
              }
            }

            .el-carousel__indicators {
              margin-top: 20px;

              .el-carousel__button {
                width: 30px;
                height: 6px;
                background-color: #cccccc;
              }

              .is-active {
                .el-carousel__button {
                  width: 50px;
                  height: 6px;
                  background-color: #c30000;
                }
              }
            }
          }
          .p1 {
            font-size: 30px;
            line-height: 30px;
            color: #333333;
            font-weight: 400;
            margin-bottom: 26px;
          }

          .line {
            width: 100%;
            height: 1px;
            background-color: #e4ebf2;
            margin-bottom: 37px;
          }

          .item {
            display: flex;
            // justify-content: center;
            align-items: center;
            font-size: 16px;
            line-height: 38px;
            color: #545454;
            font-weight: 400;

            .visd {
              visibility: hidden;
            }

            img {
              margin-right: 20px;
            }

            .label {
            }
          }

          .item1 {
            margin-bottom: 16px;
          }

          .item2 {
            margin-bottom: 16px;
          }
        }

        .right {
          flex: 1;
          width: 594px;
          height: 340px;
          // position: absolute;
          // right: 0;
          // bottom:0;
        }
      }
    }
  }

  .section2 {
    width: 100%;
    height: 800px;
    background-color: #fbfbfb;

    .s2_innerBox {
      height: 100%;

      .bodyBox {
        padding-top: 90px;
        height: 480px;
        width: 100%;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;

        .item {
          width: 590px;
          height: 240px;
          margin-bottom: 10px;
          background-color: #ffffff;
          box-shadow: 0px 5px 10px 1px rgba(0, 0, 0, 0.1);
          background-repeat: no-repeat;
          position: relative;

          .p1 {
            width: fit-content;
            height: 35px;
            line-height: 35px;
            background-color: #c30000;
            font-size: 18px;
            color: #ffffff;
            font-weight: 400;
            margin: 12px;
            padding: 0 15px;
          }

          .btBox {
            text-align: left;
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 100px;
            background-color: rgba(0, 0, 0, 0.4);
            font-size: 16px;
            line-height: 28px;
            font-weight: 400;
            color: #ffffff;
            padding: 5px 12px 0;
          }
        }

        .item1 {
          background-image: url("../../static/images/contact/浙江.jpg");
        }
        .item2 {
          background-image: url("../../static/images/contact/上海.jpg");
        }
        .item3 {
          background-image: url("../../static/images/contact/南京.jpg");
        }
        .item4 {
          background-image: url("../../static/images/contact/成都.jpg");
        }
      }
    }
  }

  .section3 {
    width: 100%;
    height: 830px;

    .s3_innerBox {
      height: 100%;

      .topTitle {
        .p1 {
          margin-top: 150px;
        }
      }

      .bodyBox {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        margin-top: 78px;

        .input {
          width: 379px;

          /deep/ .el-input__inner {
            background-color: #fbfbfb;
            color: #333333;
          }
          /deep/ .el-input__inner:focus {
            border-color: #c30000;
          }
        }

        /deep/ .el-textarea {
          margin-top: 40px;

          .el-textarea__inner {
            background-color: #fbfbfb;
            color: #333333;
          }
          .el-textarea__inner:focus {
            border-color: #c30000;
          }
        }
      }

      .btn {
        display: flex;
        justify-content: center;
        margin-top: 50px;

        .boxT {
          width: 250px;
          height: 50px;
          line-height: 50px;
          background-color: #c30000;
          color: #ffffff;
          font-size: 18px;
          cursor: pointer;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/contactEn.vue